<div class="task-list__container text-center b_radius_24 bg-light-color px-3 py-2 box-width"  #contentWrapper>
  <div class="row mx-0 mb-1">
      <div class="d-flex justify-content-between gap-1 col mb-1 p-0" >
          <div class="flex-grow-1 row mx-0 gap-1">
           <div class="col-7 text-primary-color secondary-text px-0 text-truncate text-start" ngbTooltip="{{ data?. title }}">{{ data?.title }}</div>
           <div class="col d-flex gap-2 px-0"> 
             <div class="svg" (click)="add_EditActivityComponent(data,'Edit')">
               <app-svg-icon [src]="'./assets/SVGIcons/edit.svg'" ></app-svg-icon>  
               <!-- <app-svg iconType="EditTaskList"></app-svg>  -->
             </div>
             <div class="svg "  (click)="addComment({},true)">
               <app-svg-icon [src]="'./assets/SVGIcons/comment.svg'"></app-svg-icon>
             <!-- <app-svg iconType="Comment" ></app-svg> -->
           </div>
           </div>
          </div>
       
          <div *ngIf="data?.statusName === 'Open'"  (click)="markAsComplete(data?.id)" class="text-danger-color f-11 align-self-center lh-1 hand"> <img class=" width-img" src="./assets/SVGIcons/grey-circle.svg" alt=""> </div>
          <div *ngIf="data?.statusName === 'Closed'" class="text-danger-color f-11 align-self-center lh-1"><img  class=" width-img" src="./assets/SVGIcons/circleTick.svg" alt=""></div>
          <div *ngIf="data?.statusName === 'Cancelled'" class="text-danger-color f-11 align-self-center lh-1"><img  class=" width-img" src="./assets/SVGIcons/disabled-circle-tick.svg" alt=""></div>
      </div>
      <div class="textStart primary-text  p-0 text-light-gray">
          <button class="button me-3 tab-input-label">{{ data?.statusName }}</button>
          <div class="d-flex align-items-center me-3">
            <i *ngIf="data?.priorityName=='High'" class="fa fa-circle pe-2 orange-circle"></i>
            <i *ngIf="data?.priorityName=='Critical'" class="fa fa-circle pe-2 red-circle"></i>
            <i *ngIf="data?.priorityName=='Low'" class="fa fa-circle pe-2 blue-circle"></i>
            <i *ngIf="data?.priorityName=='Standard'" class="fa fa-circle pe-2 yellow-circle"></i>
            <span class="text-info-color">{{ data?.priorityName }}</span>
          </div>
          <!-- <span class=""><span class="badge"></span>{{ data?.priority }}</span> -->
          <div class="d-flex icon">
           <ng-container *ngFor="let item of iconMappings">
        <app-svg *ngIf="data?.typeName === item.type" class="pe-2 d-flex align-items-center" [iconType]="item.icon"></app-svg>
         </ng-container>

            <span>{{ data?.typeName }}</span>
          </div>
        </div>
        <div class="text-start font-10 p-0 text-light-gray text-nowrap my-1 d-flex">
          <div class="text-decoration-underline text-semi-primary overflow-ellipsis hand" href=""  ngbTooltip="{{ data?. contactName }}" (click)="openContactInfo(data)">{{ data?. contactName }}</div>
          <span *ngIf="data?.contactName" class="text-light-info mx-1">/</span>
          <div class="text-decoration-underline text-semi-primary overflow-ellipsis hand" href=""  ngbTooltip="{{ data?. companyName }}" (click)="openCompanyInfo(data)">{{ data?.companyName }}</div>
          <span *ngIf="data?.companyName" class="text-light-info mx-2">/</span>
          <div class="text-decoration-underline text-light-info overflow-ellipsis" href=""  ngbTooltip="{{ data?. salesStageName  }}">{{ data?.salesStageName  }}</div>
        </div>
        <div class="text-start p-0 text-light-gray mb-1">
          <p class="text-overflow-example font-12"  ngbTooltip="{{ data?. description }}">{{ data?. description }}</p>
      </div>
      <div class="text-start font-10 p-0  d-flex justify-content-between"
      [ngClass]="{
        'text-red-color': data?.aging?.toLowerCase().includes('past due'),
        'text-light-gray': !data?.aging?.toLowerCase().includes('past due')
      }"
>
          <span class="font-style font-12">{{ data?.aging }}</span>
          <div class="position-relative">
            <span (click)="datePicker(data.id)" class="font-style font-12 color-pink hand">{{ data?.dueDateInFormat }}</span>
            <!-- <div class="tooltip-container"> -->
              <div *ngIf="data.datePickerShow" class="custom-tooltip" [ngClass]="{ 'add-top':tooltipPosition}">
                <div class=" with-arrow text-center datepicker bg-light-color px-3 py-2">
                  <span class="font-11 text-light-info">Snooze</span>
                  <div class="d-flex justify-content-center align-item-center mt-1 mb-2">
                    <span class="font-11 hand text-gray text-nowrap" (click)="addUpdateSnooz(1)">24 Hours</span>
                    <div class="vr"></div>
                    <span class="font-11 hand text-gray text-nowrap" (click)="addUpdateSnooz(2)">48 Hours</span>
                    <div class="vr"></div>
                    <span class="font-11 hand text-gray text-nowrap" (click)="addUpdateSnooz(3)">1 Week</span>
                  </div>
                  <hr>
                  <div class="my-2">
                    <span class="font-11 text-light-info">Change Due Date</span>
                    <form class="theme-form needs-validation novalidate" #f="ngForm" novalidate>
                      <div class="mt-2 taskdate orderDetail detail2">
                        <app-date-picker [time]="false" [inputLabel]="'Date'" [inputValue]="selectedDate"
                          (inputValueEmit)="changeDateExpiration($event);onClick()"></app-date-picker>
          
          
                      </div>
                      <div class="mt-3 tooltipTimePicker">
                         <app-ngb-timepicker
                         [label]="'Time'"
                         [id]="'time'"
                         [name]="'time'"
                         [selectedTime]="selectedTimeValue"
                         [ngbTimePickerValue]="ngbTimePickerValue"
                         (timeChange)="selectedTimeValue = $event;changeTimeExpiration($event)"
                        ></app-ngb-timepicker>
                       </div>
                    </form>
                  </div>
                </div>
              </div>
            <!-- </div> -->
          </div>
      </div>
  </div>
</div>




